import React, { FC } from "react"
import { JobActionButton } from "../../../Common/JobActionButton"
import { ReactComponent as DownloadIcon } from "icons/lib/download.svg"
import { ReactComponent as ReloadIcon } from "icons/lib/reload.svg"
import { ReactComponent as CancelIcon } from "icons/lib/cancel.svg"
import { ReactComponent as DeleteIcon } from "icons/lib/trash.svg"
import { IconEdit } from "dash-styled"

interface Props {
    className?: string
    onEdit?: () => void
    onRelabelRequest?: () => void
    onDownload?: () => void
    onCancel?: () => void
    onDelete?: () => void
}

export const JobActionsGroup: FC<Props> = ({
    className,
    onEdit,
    onRelabelRequest,
    onDownload,
    onCancel,
    onDelete
}) => {
    return (
        <div className={`flex flex-wrap ${className ?? ""}`}>
            {onDownload && (
                <JobActionButton
                    key="download"
                    Icon={DownloadIcon}
                    label="Download"
                    onClick={onDownload}
                    testId="job-download-button"
                />
            )}
            {onEdit && (
                <JobActionButton
                    key="edit"
                    Icon={IconEdit}
                    label="Edit output"
                    onClick={onEdit}
                    testId="job-output-edit-button"
                />
            )}
            {onRelabelRequest && (
                <JobActionButton
                    key="relabel"
                    Icon={ReloadIcon}
                    label="Reprocess"
                    onClick={onRelabelRequest}
                    testId="job-relabel-button"
                />
            )}
            {onCancel && (
                <JobActionButton
                    key="cancel"
                    Icon={CancelIcon}
                    label="Cancel"
                    onClick={onCancel}
                    testId="job-cancel-button"
                />
            )}
            {onDelete && (
                <JobActionButton
                    key="delete"
                    Icon={DeleteIcon}
                    label="Delete"
                    onClick={onDelete}
                    testId="job-delete-button"
                />
            )}
        </div>
    )
}
